import React from "react";
import Instagram1 from "assets/images/instagram/1.jpg";
import Instagram2 from "assets/images/instagram/2.jpg";
import Instagram3 from "assets/images/instagram/3.jpg";
import Instagram4 from "assets/images/instagram/4.jpg";
import Instagram5 from "assets/images/instagram/5.jpg";

function Instagram() {
  return (
    <div className="container-fluid bg-blackCoco p-0">
      <div className="container pt-5">
        <div className="text-end">
          <h2 className="fs-64 fw-700 hc text-end">@ELEVATEDIRON</h2>
        </div>
      </div>
      <div className="d-flex justify-content-evenly flex-wrap">
        <img src={Instagram1} alt="" className="img-fluid instaImg" />
        <img src={Instagram2} alt="" className="img-fluid instaImg" />
        <img
          src={Instagram3}
          alt=""
          className="img-fluid instaImg d-none d-sm-none d-md-none d-lg-block"
        />
        <img
          src={Instagram4}
          alt=""
          className="img-fluid instaImg d-none d-sm-none d-md-none d-lg-block"
        />
        <img
          src={Instagram5}
          alt=""
          className="img-fluid instaImg d-none d-sm-block"
        />
      </div>
    </div>
  );
}

export default Instagram;
